/**
 * The line shown under the "Assigned to me" toggle. The worklist is every transaction with an open
 * task for the user, so the page's date range does not apply to it — and the page has to say so,
 * or a date range that looks selected reads as the reason a task is missing. The distributor
 * filter does still apply, and is named whenever one is set.
 */
export function assigned_to_me_summary(row_count: number, has_distributor_filter: boolean): string {
  const distributor_note = has_distributor_filter ? " The distributor filter still applies." : ""
  if (row_count === 0) {
    return has_distributor_filter ? "You have no open tasks for this distributor." : "You have no open tasks."
  }
  const what = row_count === 1 ? "Showing the 1 transaction" : `Showing all ${row_count} transactions`
  return `${what} with an open task for you, whatever the date range.${distributor_note}`
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe("assigned_to_me_summary", () => {
    it("says the date range is not applied", () => {
      expect(assigned_to_me_summary(21, false)).toBe("Showing all 21 transactions with an open task for you, whatever the date range.")
      expect(assigned_to_me_summary(1, false)).toBe("Showing the 1 transaction with an open task for you, whatever the date range.")
    })

    it("names the distributor filter when one is narrowing the worklist", () => {
      expect(assigned_to_me_summary(4, true)).toBe(
        "Showing all 4 transactions with an open task for you, whatever the date range. The distributor filter still applies."
      )
      expect(assigned_to_me_summary(0, true)).toBe("You have no open tasks for this distributor.")
    })

    it("says so when nothing is assigned", () => {
      expect(assigned_to_me_summary(0, false)).toBe("You have no open tasks.")
    })
  })
}
